import React from "react";
import Jibber from "/app/src/jibber";
import { DateTime } from "/app/src/lib";
import { connect } from "react-redux";
import {
  Flex,
  SVGButton,
  Arrow,
  AreaInput,
  SelectInput,
  SVG,
  Div,
} from "/app/src/component";
import style from "./style.css";
import { SystemModel, FAQModel } from "/app/src/model";
import { history } from "/app/src/store";
import { FAQSelector, EmployeeSelector } from "/app/src/model/selectors";
import _ from "lodash";
import { MarkdownEditor } from "/app/src/component";

const Container = {
  hAlignContent: "center",
  column: true,
  w: "100%",
  shrink: 0,
  backgroundColor: "#f0f0f0",
};

class CategoryItemEditor extends Jibber {
  constructor(props) {
    super(props);
    this.useState({
      answer: props.answer,
      question: props.question,
      authorImg: props.authorImg,
      authorName: props.authorName,
      author: props.authorName ? "-1" : "0",
      titleRequired: false,
    });

    this.onUpdateButtonClick = this.onUpdateButtonClick.bind(this);
    this.onSaveButtonClick = this.onSaveButtonClick.bind(this);
  }

  componentDidMount() {
    this.props.currentPayloadDispatcher(this.craftPayload());
    if (this.props.action === "update") {
      const { date_created, categoryId, readItems } = this.props;
      //indication of we do not have the item in redux state
      if (!date_created) {
        readItems(categoryId);
      }
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.action === "update") {
      if (!state.question) {
        return {
          answer: props.answer,
        };
      }
    }
    return null;
  }

  onUpdateButtonClick(question, answer, displayName, imgUrl) {
    if (!this.state.question) {
      this.setTitleRequired(true);
    } else {
      this.props.updateItem(this.props.id, {
        question: question,
        answer: answer,
        displayName: displayName,
        imgUrl: imgUrl,
        author_img: imgUrl,
        author_name: displayName,
      });
    }
  }

  onSaveButtonClick(question, answer, displayName, imgUrl) {
    if (!this.state.question) {
      this.setTitleRequired(true);
    } else {
      history.push(
        "/clientChat/faq/helpdesk/category/" + this.props.categoryId
      );
      this.props.createFaqItem(
        question,
        answer,
        displayName,
        imgUrl,
        this.props.categoryId
      );
    }
  }

  craftPayload() {
    const temp = {
      question: this.state.question,
      answer: this.state.answer,
      authorName: this.state.authorName,
      authorImg: this.state.authorImg,
    };
    return temp;
  }

  render() {
    const props = this.props;
    const { answer, question, authorImg, authorName, loading } = this.state;
    const { setQuestion, setAuthorImg, setAuthorName } = this;
    if (props.network.fetching) {
      return "";
    }

    const isUpdateView = props.action === "update";
    const isCreateView = props.action === "create";

    const authorsValue = { "-1": "Välj skribent", 0: "Ingen skribent" };
    _.forEach(props.employees, (e) => {
      let displayName = e.display_name;

      if (!displayName) {
        displayName = e.name;
      }
      authorsValue[e.id] = displayName;
    });

    const Header = {
      shrink: 0,
      vAlignContent: "center",
      w: "100%",
      h: "70px",
      color: "grey",
      fontSize: "26px",
      fontWeight: "500",
      backgroundColor: "white",
    };
    const BackArrowButton = {
      onClick: (e) => {
        e.stopPropagation();
        history.goBack();
      },
      text: "Tillbaka till Feedback",
      direction: "left",
      color: "grey",
      hover: "blue",
    };
    const PreviewButton = {
      onClick: (e) => {
        e.stopPropagation();
        this.props.currentPayloadDispatcher(this.craftPayload());
      },
      text: "Förhandsgranska",
      border: true,
      borderRadius: "30px",
      color: "black",
      hover: "blue",
      backgroundColor: "white",
      height: "49px",
      ml: "auto",
      padding: "10px",
    };
    const UpdateButton = {
      onClick: (e) => {
        e.stopPropagation();
        this.onUpdateButtonClick(question, answer, authorName, authorImg);
      },
      text: "Spara",
      border: true,
      src: "/images/Save.svg",
      borderRadius: "30px",
      color: "black",
      hover: "blue",
      backgroundColor: "white",
      height: "49px",
      mx: "10px",
      disabled: !this.state.changed,
    };
    const CreateButton = {
      onClick: (e) => {
        e.stopPropagation();
        this.onSaveButtonClick(question, answer, authorName, authorImg);
      },
      text: "Skapa",
      src: "/images/Save.svg",
      border: true,
      mx: "10px",
      height: "49px",
      backgroundColor: "white",
      borderRadius: "30px",
      color: "black",
    };

    return (
      <Flex {...Container}>
        <Flex {...Header}>
          <Arrow {...BackArrowButton} />
          <SVGButton {...PreviewButton} />
          {isUpdateView && <SVGButton {...UpdateButton} />}
          {isCreateView && <SVGButton {...CreateButton} />}
        </Flex>
        <Div overflowY="auto" width="100%">
          <Flex
            backgroundColor="#f0f0f0"
            column
            w="100%"
            px="60px"
            py="15px"
            shrink={0}
          >
            {isUpdateView && (
              <React.Fragment>
                <Flex
                  shrink={0}
                  fontSize="18px"
                  fontWeight="400"
                  color="#6c6c6c"
                  ml="auto"
                >
                  <Flex column hAlignContent="right">
                    <Flex>Uppdaterad:</Flex>
                    <Flex>Skapad:</Flex>
                  </Flex>
                  <Flex column ml="10px">
                    <Flex>{props.date_modified}</Flex>
                    <Flex>{props.date_created}</Flex>
                  </Flex>
                </Flex>
              </React.Fragment>
            )}

            <Flex fontSize="24px" mb="5px">
              Fråga (Titel)
            </Flex>
            <AreaInput
              value={question}
              name="question"
              onChange={(e) => setQuestion(e.target.value)}
            />
            {this.state.titleRequired && (
              <Flex color="#ff4e00" center shrink={0}>
                <SVG
                  cacheGetRequests={true}
                  style={{
                    fill: "#ff4e00",
                    height: "15px",
                    width: "15px",
                    marginLeft: "5px",
                  }}
                  src="/images/Required_Star.svg"
                />
                Du måste ange titel.
              </Flex>
            )}
            <Flex height="400px" marginTop="20px" shrink={0}>
              {!loading && (
                <MarkdownEditor
                  option="advance"
                  label="Artikel (Svar)"
                  height="300px"
                  text={answer}
                  onTextChange={(content) => this.setAnswer(content)}
                />
              )}
            </Flex>
            <Flex w="100%" shrink={0}>
              <Flex w="50%" my="23px" vAlignContent="center" shrink={0}>
                <Flex mr="10px" shrink={0}>
                  Skribent
                </Flex>
                <SelectInput
                  values={authorsValue}
                  select={"-1"}
                  onChange={(e) => {
                    e.stopPropagation();
                    if (e.target.value === "-1") return;
                    if (e.target.value === "0") {
                      setAuthorImg("");
                      setAuthorName("");
                    } else {
                      let employee = props.employees[e.target.value];
                      let authorName = employee.display_name;
                      let authorImg = employee.image_url;

                      if (!authorName) {
                        authorName = employee.name;
                      }
                      setAuthorName(authorName);
                      setAuthorImg(authorImg);
                    }
                  }}
                />
              </Flex>
            </Flex>
            {authorName && (
              <Flex vAlignContent="center" shrink={0}>
                <img
                  alt="author"
                  src={authorImg || "/images/employee-avatar.png"}
                  className={style.AuthorImage}
                />
                <Flex shrink={0}>{authorName}</Flex>
              </Flex>
            )}
          </Flex>
        </Div>
      </Flex>
    );
  }
}

const { dispatcher: faqCreateDispatcher } = FAQModel.createItemRequest();
const { dispatcher: faqUpdateDispatcher } = FAQModel.updateItemRequest();
const {
  selector: categoryItemSelector,
  dispatcher: categoryItemRead,
} = FAQModel.readItemsByCategoryRequest();
const {
  dispatcher: currentPayloadDispatcher,
} = FAQModel.setFaqCurrentPayload();

const mapDispatchToProps = (dispatch) => ({
  navigateTo: (to) => {
    dispatch(SystemModel.navigateTo(to));
  },
  createFaqItem: (question, answer, authorName, authorImg, categoryId) => {
    dispatch(
      faqCreateDispatcher(question, answer, authorName, authorImg, categoryId)
    );
  },
  updateItem: (faqId, updates) => {
    dispatch(faqUpdateDispatcher(faqId, updates));
  },
  readItems: (categoryId) => {
    dispatch(categoryItemRead(categoryId));
  },
  currentPayloadDispatcher: (payload) =>
    dispatch(currentPayloadDispatcher(payload)),
});
function mapStateToProps(state, props) {
  var categoryId = parseInt(props.match.params["id"], 10);
  var itemId = props.match.params["itemId"];
  var action = props.match.params.action;
  let network = categoryItemSelector(state)["network"];
  let employees = EmployeeSelector.getAll(state).toJS();
  switch (action) {
    case "update":
      let item = FAQSelector.getFAQById(state, itemId).toJS();
      return {
        answer: item.answer,
        categoryId: categoryId,
        id: itemId,
        question: item.question,
        authorImg: item.author_img,
        authorName: item.author_name,
        action: action,
        employees: employees,
        date_modified: DateTime.getFormatDate(item.date_modified),
        date_created: DateTime.getFormatDate(item.date_created),
        network: network.toJS(),
      };
    case "create":
    default:
      return {
        employees: employees,
        answer: "",
        categoryId: categoryId,
        id: -1,
        question: "",
        action: action,
        network: network.toJS(),
      };
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CategoryItemEditor);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Category/Item.js